import { z } from 'zod';

export const CoreNotifySettingScalarFieldEnumSchema = z.enum(['id','cityId','createdAt','updatedAt','twilioAccountSid','suspendedAt','smsTwilioMessagingServiceSid','smsBrandName','voiceTwilioPhoneNumberSid','voiceTwilioPhoneNumber','voiceBrandName','voiceTextToSpeechVoice','billingAccountId']);

export default CoreNotifySettingScalarFieldEnumSchema;
